/* tslint:disable */
/* eslint-disable */
/**
 * Portal Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DeleteFeedbackRequest interface.
 */
export function instanceOfDeleteFeedbackRequest(value) {
    return true;
}
export function DeleteFeedbackRequestFromJSON(json) {
    return DeleteFeedbackRequestFromJSONTyped(json, false);
}
export function DeleteFeedbackRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'feedbackId': json['feedback_id'] == null ? undefined : json['feedback_id'],
    };
}
export function DeleteFeedbackRequestToJSON(json) {
    return DeleteFeedbackRequestToJSONTyped(json, false);
}
export function DeleteFeedbackRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'feedback_id': value['feedbackId'],
    };
}
